<template>
    <span :class="['badge', `badge-${size}`, `badge-${color}`]">
        {{ label }}
    </span>
</template>
<script>
export default {
    name: "BadgeStatusAcesso",
    props: {
        status: {
            type: [Number],
            default: 1
        },
        size: {
            type: String,
            default: 'md'
        }
    },
    computed: {
        label() {
            const labels = {
                1: 'Agendado',
                2: 'Acesso Concedido',
                3: 'Agendamento Cancelado',
                4: 'Acesso Cancelado',
                5: 'Acesso Expirado',
            }
            return labels[this.status];
        },
        color() {
            const colors = {
                1: 'primary',
                2: 'success',
                3: 'danger',
                4: 'warning',
                5: 'secondary',
            }
            return colors[this.status];
        }
    }
}
</script>